<template>
  <div class="real-verify-rules" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k069') }} {{ $t('lang.BaseCommon.k005') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <section class="block">
        <h2 class="section-title">{{ $t('lang.RealVerifyRules.k001') }}</h2>
        <ul class="rule-list">
          <li v-for="(text, i) in positiveRules" :key="'p' + i" class="rule-row">
            <img class="rule-icon rule-icon--ok" :src="icons.ok" alt="" />
            <span class="rule-text">{{ text }}</span>
          </li>
        </ul>
        <div class="thumbs">
          <div v-for="(src, i) in positiveThumbs" :key="'pt' + i" class="thumb-wrap">
            <div class="thumb">
              <img :src="src" alt="" class="thumb-img" />
            </div>
            <div class="badge badge--ok">
              <img :src="icons.ok" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section class="block block--second">
        <h2 class="section-title">{{ $t('lang.RealVerifyRules.k002') }}</h2>
        <ul class="rule-list">
          <li v-for="(text, i) in negativeRules" :key="'n' + i" class="rule-row">
            <img class="rule-icon rule-icon--bad" :src="icons.notOk" alt="" />
            <span class="rule-text">{{ text }}</span>
          </li>
        </ul>
        <div class="thumbs">
          <div v-for="(src, i) in negativePhotos" :key="'nt' + i" class="thumb-wrap">
            <div class="thumb">
              <img :src="src" alt="" class="thumb-img" />
            </div>
            <div class="badge badge--bad">
              <img :src="icons.notOk" alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  name: 'RealVerifyRules',
  data() {
    return {
      icons: {
        notOk: require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/not-ok.png'),
        ok: require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/ok.png'),
      },
      positiveThumbs: [
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-1.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-2.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-3.png'),
      ],
      negativePhotos: [
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-4.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-5.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-6.png'),
      ],
      // prettier-ignore
      positiveRules: [
        this.$t('lang.RealVerifyRules.k003'),
        this.$t('lang.RealVerifyRules.k004'),
        this.$t('lang.RealVerifyRules.k005'),
      ],
      // prettier-ignore
      negativeRules: [
        this.$t('lang.RealVerifyRules.k006'),
        this.$t('lang.RealVerifyRules.k008'),
        this.$t('lang.RealVerifyRules.k009'),
      ],
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>

<style lang="scss" scoped>
.real-verify-rules {
  min-height: 100vh;
  background: #f9f9fb;
}

.custom-nav-block {
  background-color: #f9f9fb;
  .van-bar {
    ::v-deep .van-nav-bar__left .tit-left {
      font-family: var(--string-font);
      font-size: var(--fs-20);
      font-weight: var(--fw-900);
      line-height: var(--lh-title-24);
      color: #333333;
    }
  }
}

.main {
  padding: 16px 16px 32px;
}

.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.block--second {
  margin-top: 64px;
}

.section-title {
  margin: 0 0 16px;
  width: 100%;
  max-width: 267px;
  color: #333;
  text-align: center;
  font-family: var(--string-font);
  font-size: var(--fs-16);
  font-weight: var(--fw-700);
  line-height: var(--lh-title-28);
}

.rule-list {
  margin: 0 0 16px;
  padding: 0;
  list-style: none;
  width: 100%;
  max-width: 267px;
}

.rule-row {
  display: flex;
  align-items: flex-start;
  gap: 2px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.rule-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: 2px;
  box-sizing: border-box;
  position: relative;
}

.rule-text {
  flex: 1;
  max-width: 245px;
  color: #333;
  font-family: var(--string-font);
  font-size: var(--fs-14);
  font-weight: var(--fw-400);
  line-height: var(--lh-body-20);
}

.thumbs {
  display: flex;
  justify-content: center;
  gap: 9px;
  width: 100%;
  max-width: 267px;
}

.thumb-wrap {
  position: relative;
  width: 83px;
  height: 110px;
  flex-shrink: 0;
}

.thumb {
  width: 83px;
  height: 110px;
  border-radius: 6px;
  overflow: hidden;
  background: #eee;
}

.thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.badge {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 24px;
  height: 24px;

  &--ok img,
  &--bad img {
    width: 24px;
    height: 24px;
    display: block;
  }
}
</style>
